import React, { Component } from "react";
import { PropTypes } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Reusable info tooltip icon.
 * Renders a "?" circle icon that shows a tooltip on hover.
 */
class InfoTooltip extends Component {
  render() {
    const { text, id } = this.props;
    const tooltip = <Tooltip id={id}>{text}</Tooltip>;
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <span className="info-tooltip-icon">?</span>
      </OverlayTrigger>
    );
  }
}

InfoTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default InfoTooltip;



// WEBPACK FOOTER //
// ./src/components/common/Tooltip/InfoTooltip.js